<template>
  <template v-if="items && items.length > 0">
    <TGrid :gap-y="8" class="s-deals">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="col-span-12 md:col-span-6"
      >
        <TDeal v-bind="item" />
      </div>
    </TGrid>
  </template>
</template>

<script setup lang="ts">
import { type Props } from '~~/modules/design-system/components/t-deal/index.vue'

export interface propsInterface {
  items: Array<Props>
}

defineProps<propsInterface>()
</script>
